import { AfterViewInit, Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { COLORS } from './config'

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    const colors = COLORS

    for (const [name, value] of Object.entries(colors)) {
      document.documentElement.style.setProperty(`--label-${name}`, value)
    }
  }
}
